module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving4-e8ab920b20d2ced966a3ff5045721f77.jpg";